<script lang="ts">
	import { viewport } from '@wiseed/wikit';
	import { Dropdown } from '@wiseed/wikit';
	import { urls } from '@app/urls';
	import { goto } from '$app/navigation';
	import UserNavNotificationsItemMobile from './UserNavNotificationsItemMobile.svelte';
	import UserNavNotificationsItemDesktop from './UserNavNotificationsItemDesktop.svelte';
	import UserAvatar from '@app/components/user/UserAvatar.svelte';
	import UserNavAccountStatus from './UserNavAccountStatus.svelte';
	import { isSidebarOpen } from '@app/stores/sidebar';
	import { SVG } from '@wiseed/wikit';
	import UserNavLinks from '@app/components/nav/userNav/UserNavLinks.svelte';
	import UserNavIdentity from '@app/components/nav/userNav/UserNavIdentity.svelte';
	import UserNavInstallAppCTA from '@app/components/nav/NavInstallAppCTA.svelte';

	let isUserDropdownOpen = false;
	let userDropdownTriggerRef = null;

	const handleAvatarClick = () => {
		if ($viewport.isMobile) {
			goto(urls.USER.DASHBOARD);
			$isSidebarOpen = false;
		} else {
			isUserDropdownOpen = !isUserDropdownOpen;
		}
	};
</script>

<div class="relative lg:order-last pt-2">
	<div
		class="flex items-center justify-between lg:flex-row-reverse lg:space-x-4 lg:space-x-reverse"
	>
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<!-- svelte-ignore a11y-no-static-element-interactions -->
		<div class="w-full">
			<div class="flex items-center gap-3 w-full justify-between">
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<div
					bind:this={userDropdownTriggerRef}
					on:click={handleAvatarClick}
					class="flex items-center gap-3 relative cursor-pointer"
				>
					<UserAvatar props={{ size: 'default' }} />
					<div class=" hidden lg:block">
						<UserNavIdentity />
					</div>
					<SVG name="keyboard_arrow_down" size="small" classNames="hidden lg:block" />
					<Dropdown
						position="right"
						isOpen={isUserDropdownOpen}
						close={() => (isUserDropdownOpen = false)}
						triggerRef={userDropdownTriggerRef}
						classNames="hidden lg:block lg:space-y-3"
					>
						<UserNavAccountStatus />
						<UserNavLinks />
					</Dropdown>
				</div>
				{#if $viewport.isDesktop}
					<UserNavNotificationsItemDesktop />
					<UserNavInstallAppCTA />
				{:else}
					<UserNavNotificationsItemMobile />
				{/if}
			</div>
		</div>
	</div>
	<div class="lg:hidden pt-3 space-y-3">
		<div>
			<UserNavIdentity />
		</div>
		<UserNavAccountStatus />
		<div class="pb-4">
			<UserNavLinks />
		</div>
	</div>
</div>
